export const FEEDBACK_EN = {
    'nav.module.feedback': 'Reports',
    'nav.feedback.mine': 'My reports',
    'nav.feedback.reports': 'Reports',
    'screen.feedback.reports.title': 'Reports',
    'screen.feedback.report.title': 'Report',
    'screen.feedback.mine.title': 'My reports',
    // ── the entry, the picker, the dialog (shell) ──
    'feedback.open': 'Report a problem or a suggestion',
    'feedback.menu': 'Reports',
    'feedback.from_conversation': 'Turn this conversation into a report',
    'feedback.open.short': 'Report',
    'feedback.palette': 'Report a problem or a suggestion',
    'feedback.palette.mine': 'My reports',
    'feedback.picker.hint': 'Click the part the problem is in',
    'feedback.picker.keys': 'Tab moves between parts, Enter picks, Esc cancels',
    'feedback.picker.page': 'The whole page',
    'feedback.picker.cancel': 'Cancel',
    'feedback.part.page': 'The whole page',
    'feedback.part.figures': 'The page\'s figures',
    'feedback.part.part': 'Card',
    'feedback.part.figure': 'Figure',
    'feedback.part.table': 'Table',
    'feedback.part.row': 'Row',
    'feedback.part.section': 'Section',
    'feedback.part.dialog': 'Window',
    'feedback.part.field': 'Field',
    'feedback.part.button': 'Button',
    'feedback.part.message': 'Message',
    'feedback.part.link': 'Link',
    'feedback.dialog.title': 'New report',
    'feedback.dialog.kind': 'Type',
    'feedback.dialog.part': 'The part you picked',
    'feedback.dialog.change_part': 'Change the part',
    'feedback.dialog.description.problem': 'What happened?',
    'feedback.dialog.description.suggestion': 'What would you suggest?',
    'feedback.dialog.attach': 'Attach a picture of the part you picked (you see it before sending, and can remove it)',
    'feedback.dialog.capturing': 'Taking the picture…',
    'feedback.dialog.capture_failed': 'The picture of this part could not be taken. You can send without it.',
    'feedback.dialog.capture_large': 'Even made smaller, the picture is over 600 KB, so it will not be attached.',
    'feedback.dialog.picture': 'The picture that will be sent',
    'feedback.dialog.remove_picture': 'Remove the picture',
    'feedback.dialog.conversation': 'Attach my latest conversation with the assistant ({count})',
    'feedback.dialog.conversation.show': 'Show it',
    'feedback.dialog.conversation.hide': 'Hide it',
    'feedback.dialog.conversation.preview': 'The conversation that will be sent',
    'feedback.dialog.conversation.trimmed': 'Shortened: only the latest messages are sent.',
    'feedback.dialog.context': 'Sent with it automatically: the page and the part, the system version, the language, the browser and the time. No data from the table is sent, except what is in the picture and in the conversation with the assistant, if you attach them.',
    'feedback.dialog.privacy': 'The workspace\'s administrator and the product team read it.',
    'feedback.dialog.send': 'Send the report',
    'feedback.dialog.sending': 'Sending…',
    'feedback.dialog.improve': 'Improve the wording with the assistant',
    'feedback.dialog.improving': 'The assistant is rewording…',
    'feedback.dialog.suggested': 'The assistant\'s wording',
    'feedback.dialog.accept': 'Use this wording',
    'feedback.dialog.keep': 'Keep mine',
    'feedback.dialog.improve_failed': 'The assistant could not reword it just now.',
    'feedback.dialog.cancel': 'Cancel',
    'feedback.dialog.sent': 'Report sent. Follow it on «My reports».',
    'feedback.dialog.failed': 'The report was not sent: {detail}',
    // ── the vocabulary ──
    'feedback.kind.problem': 'Problem',
    'feedback.kind.suggestion': 'Suggestion',
    'feedback.status.new': 'New',
    'feedback.status.reviewing': 'Under review',
    'feedback.status.resolved': 'Resolved',
    'feedback.status.wont_do': 'Won\'t be done',
    'feedback.locale.ar': 'Arabic',
    'feedback.locale.en': 'English',
    // ── the administrator's list, the record page, «My reports» ──
    'feedback.reports.title': 'Reports',
    'feedback.reports.lede': "Problems and suggestions members sent, each with the part of the screen it is about.",
    'feedback.report.title': 'Report',
    'feedback.report.monogram': 'ب',
    'feedback.mine.title': 'My reports',
    'feedback.mine.lede': 'What you reported and what became of it: its status and the latest reply.',
    'feedback.stat.new': 'New',
    'feedback.stat.reviewing': 'Under review',
    'feedback.stat.problems': 'Problems',
    'feedback.stat.resolved': 'Resolved',
    'feedback.col.kind': 'Type',
    'feedback.col.description': 'Description',
    'feedback.col.place': 'Part',
    'feedback.col.reporter': 'Sent by',
    'feedback.col.reporter_party': 'Person',
    'feedback.col.created_by': 'Sent by (user)',
    'feedback.col.created_at': 'Sent',
    'feedback.col.status': 'Status',
    'feedback.col.screen_key': 'Screen',
    'feedback.col.part_label': 'Part',
    'feedback.col.part_key': 'Part key',
    'feedback.col.route': 'Page',
    'feedback.col.reply': 'Latest reply',
    'feedback.col.replied_at': 'Replied',
    'feedback.col.has_screenshot': 'Picture',
    'feedback.col.screenshot': 'Picture of the part',
    'feedback.col.can_decide': 'Yours to answer',
    'feedback.col.status_changed_at': 'Status changed',
    'feedback.col.app_version': 'Version',
    'feedback.col.locale': 'Language',
    'feedback.col.user_agent': 'Browser',
    'feedback.col.id': 'Id',
    'feedback.action.status': 'Change status / reply',
    'feedback.field.reply': 'Reply to the reporter',
    'feedback.field.reply.help': 'The reporter reads it on «My reports».',
    'feedback.card.description': 'Description',
    'feedback.card.screenshot': 'Picture of the part',
    'feedback.card.reply': 'Reply to the reporter',
    'feedback.card.reply.empty': 'No reply yet.',
    'feedback.card.conversation': 'The conversation with the assistant',
    'feedback.col.conversation': 'The conversation with the assistant',
    'feedback.col.has_conversation': 'Conversation attached',
    // ── refusals ──
    'feedback.refusal.kind': 'Choose whether it is a problem or a suggestion.',
    'feedback.refusal.status': 'The status is new, under review, resolved or won\'t be done.',
    'feedback.refusal.part_kind': 'The part picked is not one the report knows.',
    'feedback.refusal.locale': 'The language is Arabic or English.',
    'feedback.refusal.description_required': 'Say what happened, or what you would suggest.',
    'feedback.refusal.not_text': 'This must be text.',
    'feedback.refusal.too_long': 'This is longer than {max} characters.',
    'feedback.refusal.part_box': 'The part\'s place on the screen could not be read.',
    'feedback.refusal.screenshot': 'The picture must be a PNG or WebP image.',
    'feedback.refusal.screenshot_large': 'The picture is larger than {max_kb} KB.',
    'feedback.refusal.conversation': 'The conversation is a list of messages, each from you or the assistant, with its words.',
    'feedback.refusal.conversation_large': 'The conversation is longer than {max_messages} messages or {max_kb} KB.',
    'feedback.refusal.screen_key': 'The screen is not named the way the platform names screens.',
    'feedback.refusal.reported_at': 'The moment of the report could not be read.',
    'feedback.refusal.not_found': 'No such report.',
    'feedback.refusal.own_report': 'Nobody decides their own report: another administrator answers it.',
    'feedback.refusal.priority': 'Choose a priority: low, medium, high or critical.',
    // ── what the change record keeps ──
    'change.field.report.kind': 'Type',
    'change.field.report.description': 'Description',
    'change.field.report.status': 'Status',
    'change.field.report.reply': 'Reply',
    'change.field.report.replied_at': 'Replied',
    'change.field.report.replied_by': 'Replied by',
    'change.field.report.route': 'Page',
    'change.field.report.screen_key': 'Screen',
    'change.field.report.part_kind': 'Kind of part',
    'change.field.report.part_key': 'Part key',
    'change.field.report.part_label': 'Part',
    'change.field.report.app_version': 'Version',
    'change.field.report.locale': 'Language',
    'change.field.report.user_agent': 'Browser',
    'change.field.report.reported_at': 'Reported at',
    'change.field.report.screenshot': 'Picture',
    'change.field.report.screenshot_type': 'Picture type',
    'change.field.report.conversation': 'Conversation with the assistant',
    'change.field.report.reporter_party': 'Person',
    'change.field.report.status_changed_at': 'Status changed',
    'change.field.report.status_changed_by': 'Status changed by',
    'change.field.report.created_by': 'Sent by',
};
export const FEEDBACK_AR = {
    'nav.module.feedback': 'البلاغات',
    'nav.feedback.mine': 'بلاغاتي',
    'nav.feedback.reports': 'البلاغات',
    'screen.feedback.reports.title': 'البلاغات',
    'screen.feedback.report.title': 'بلاغ',
    'screen.feedback.mine.title': 'بلاغاتي',
    'feedback.open': 'أبلغ عن مشكلة أو اقتراح',
    'feedback.menu': 'البلاغات',
    'feedback.from_conversation': 'حوّل المحادثة إلى بلاغ',
    'feedback.open.short': 'أبلغ',
    'feedback.palette': 'أبلغ عن مشكلة أو اقتراح',
    'feedback.palette.mine': 'بلاغاتي',
    'feedback.picker.hint': 'اضغط على الجزء الذي فيه المشكلة',
    'feedback.picker.keys': 'Tab للتنقل بين الأجزاء، وEnter للاختيار، وEsc للإلغاء',
    'feedback.picker.page': 'الصفحة كلها',
    'feedback.picker.cancel': 'إلغاء',
    'feedback.part.page': 'الصفحة كلها',
    'feedback.part.figures': 'أرقام الصفحة',
    'feedback.part.part': 'بطاقة',
    'feedback.part.figure': 'رقم',
    'feedback.part.table': 'جدول',
    'feedback.part.row': 'صف',
    'feedback.part.section': 'قسم',
    'feedback.part.dialog': 'نافذة',
    'feedback.part.field': 'حقل',
    'feedback.part.button': 'زر',
    'feedback.part.message': 'رسالة',
    'feedback.part.link': 'رابط',
    'feedback.dialog.title': 'بلاغ جديد',
    'feedback.dialog.kind': 'النوع',
    'feedback.dialog.part': 'الجزء المختار',
    'feedback.dialog.change_part': 'غيّر الجزء',
    'feedback.dialog.description.problem': 'ماذا حدث؟',
    'feedback.dialog.description.suggestion': 'ما الذي تقترحه؟',
    'feedback.dialog.attach': 'أرفق صورة الجزء المختار (تراها قبل الإرسال، ويمكنك إزالتها)',
    'feedback.dialog.capturing': 'تُلتقط الصورة…',
    'feedback.dialog.capture_failed': 'تعذّر التقاط صورة هذا الجزء. يمكنك الإرسال بدونها.',
    'feedback.dialog.capture_large': 'الصورة أكبر من 600 كيلوبايت حتى بعد تصغيرها، فلن تُرفق.',
    'feedback.dialog.picture': 'الصورة التي ستُرسل',
    'feedback.dialog.remove_picture': 'أزل الصورة',
    'feedback.dialog.conversation': 'أرفق محادثتي الأخيرة مع المساعد ({count})',
    'feedback.dialog.conversation.show': 'اعرضها',
    'feedback.dialog.conversation.hide': 'أخفها',
    'feedback.dialog.conversation.preview': 'المحادثة التي ستُرسل',
    'feedback.dialog.conversation.trimmed': 'تم اختصارها: تُرسل آخر الرسائل فقط.',
    'feedback.dialog.context': 'يُرسل معها تلقائياً الصفحة والجزء، ونسخة النظام، واللغة والمتصفح والوقت. لا تُرسل أي بيانات من الجدول إلا ما في الصورة وفي المحادثة مع المساعد إن أرفقتهما.',
    'feedback.dialog.privacy': 'يراه مسؤول المساحة وفريق المنتج.',
    'feedback.dialog.send': 'أرسل البلاغ',
    'feedback.dialog.sending': 'يُرسل…',
    'feedback.dialog.improve': 'حسّن الصياغة مع المساعد',
    'feedback.dialog.improving': 'يعيد المساعد الصياغة…',
    'feedback.dialog.suggested': 'صياغة المساعد',
    'feedback.dialog.accept': 'استخدم هذه الصياغة',
    'feedback.dialog.keep': 'أبقِ نصّي',
    'feedback.dialog.improve_failed': 'لم يتمكن المساعد من إعادة الصياغة الآن.',
    'feedback.dialog.cancel': 'إلغاء',
    'feedback.dialog.sent': 'أُرسل البلاغ. تتابعه في «بلاغاتي».',
    'feedback.dialog.failed': 'لم يُرسل البلاغ: {detail}',
    'feedback.kind.problem': 'مشكلة',
    'feedback.kind.suggestion': 'اقتراح',
    'feedback.status.new': 'جديد',
    'feedback.status.reviewing': 'قيد الدراسة',
    'feedback.status.resolved': 'حُلّت',
    'feedback.status.wont_do': 'لن تُنفَّذ',
    'feedback.locale.ar': 'العربية',
    'feedback.locale.en': 'الإنجليزية',
    'feedback.reports.title': 'البلاغات',
    'feedback.reports.lede': "المشكلات والاقتراحات التي أرسلها الأعضاء، مع الجزء من الشاشة الذي تخصّه.",
    'feedback.report.title': 'بلاغ',
    'feedback.report.monogram': 'ب',
    'feedback.mine.title': 'بلاغاتي',
    'feedback.mine.lede': 'ما أبلغت عنه وما صار إليه: حالته وآخر ردّ عليه.',
    'feedback.stat.new': 'جديدة',
    'feedback.stat.reviewing': 'قيد الدراسة',
    'feedback.stat.problems': 'مشكلات',
    'feedback.stat.resolved': 'حُلّت',
    'feedback.col.kind': 'النوع',
    'feedback.col.description': 'الوصف',
    'feedback.col.place': 'الجزء',
    'feedback.col.reporter': 'من',
    'feedback.col.reporter_party': 'الشخص',
    'feedback.col.created_by': 'من (المستخدم)',
    'feedback.col.created_at': 'أُرسل',
    'feedback.col.status': 'الحالة',
    'feedback.col.screen_key': 'الشاشة',
    'feedback.col.part_label': 'الجزء',
    'feedback.col.part_key': 'مفتاح الجزء',
    'feedback.col.route': 'الصفحة',
    'feedback.col.reply': 'آخر ردّ',
    'feedback.col.replied_at': 'وقت الرد',
    'feedback.col.has_screenshot': 'صورة',
    'feedback.col.screenshot': 'صورة الجزء',
    'feedback.col.can_decide': 'لك أن تردّ عليه',
    'feedback.col.status_changed_at': 'تغيّرت الحالة',
    'feedback.col.app_version': 'النسخة',
    'feedback.col.locale': 'اللغة',
    'feedback.col.user_agent': 'المتصفح',
    'feedback.col.id': 'المعرّف',
    'feedback.action.status': 'غيّر الحالة / ردّ',
    'feedback.field.reply': 'ردّ على صاحب البلاغ',
    'feedback.field.reply.help': 'يقرؤه صاحب البلاغ في «بلاغاتي».',
    'feedback.card.description': 'الوصف',
    'feedback.card.screenshot': 'صورة الجزء',
    'feedback.card.reply': 'الردّ على صاحب البلاغ',
    'feedback.card.reply.empty': 'لا ردّ بعد.',
    'feedback.card.conversation': 'المحادثة مع المساعد',
    'feedback.col.conversation': 'المحادثة مع المساعد',
    'feedback.col.has_conversation': 'أُرفقت المحادثة',
    'feedback.refusal.kind': 'اختر: مشكلة أم اقتراح.',
    'feedback.refusal.status': 'الحالة: جديد، أو قيد الدراسة، أو حُلّت، أو لن تُنفَّذ.',
    'feedback.refusal.part_kind': 'الجزء المختار ليس مما يعرفه البلاغ.',
    'feedback.refusal.locale': 'اللغة العربية أو الإنجليزية.',
    'feedback.refusal.description_required': 'اكتب ما حدث، أو ما تقترحه.',
    'feedback.refusal.not_text': 'يجب أن يكون نصاً.',
    'feedback.refusal.too_long': 'أطول من {max} حرفاً.',
    'feedback.refusal.part_box': 'تعذّرت قراءة موضع الجزء على الشاشة.',
    'feedback.refusal.screenshot': 'الصورة يجب أن تكون PNG أو WebP.',
    'feedback.refusal.screenshot_large': 'الصورة أكبر من {max_kb} كيلوبايت.',
    'feedback.refusal.conversation': 'المحادثة قائمة رسائل، كل منها منك أو من المساعد، ومعها نصها.',
    'feedback.refusal.conversation_large': 'المحادثة أطول من {max_messages} رسالة أو {max_kb} كيلوبايت.',
    'feedback.refusal.screen_key': 'اسم الشاشة ليس بالصيغة التي تسمّي بها المنصة شاشاتها.',
    'feedback.refusal.reported_at': 'تعذّرت قراءة وقت البلاغ.',
    'feedback.refusal.not_found': 'لا يوجد بلاغ كهذا.',
    'feedback.refusal.own_report': 'لا يبتّ أحد في بلاغه: يردّ عليه مسؤول آخر.',
    'feedback.refusal.priority': 'اختر الأهمية: منخفضة أو متوسطة أو عالية أو حرجة.',
    'change.field.report.kind': 'النوع',
    'change.field.report.description': 'الوصف',
    'change.field.report.status': 'الحالة',
    'change.field.report.reply': 'الردّ',
    'change.field.report.replied_at': 'وقت الردّ',
    'change.field.report.replied_by': 'صاحب الردّ',
    'change.field.report.route': 'الصفحة',
    'change.field.report.screen_key': 'الشاشة',
    'change.field.report.part_kind': 'نوع الجزء',
    'change.field.report.part_key': 'مفتاح الجزء',
    'change.field.report.part_label': 'الجزء',
    'change.field.report.app_version': 'النسخة',
    'change.field.report.locale': 'اللغة',
    'change.field.report.user_agent': 'المتصفح',
    'change.field.report.reported_at': 'وقت البلاغ',
    'change.field.report.screenshot': 'الصورة',
    'change.field.report.screenshot_type': 'نوع الصورة',
    'change.field.report.conversation': 'المحادثة مع المساعد',
    'change.field.report.reporter_party': 'الشخص',
    'change.field.report.status_changed_at': 'وقت تغيّر الحالة',
    'change.field.report.status_changed_by': 'من غيّر الحالة',
    'change.field.report.created_by': 'من أرسله',
};
//# sourceMappingURL=i18n-feedback.js.map